import { toObjectMap } from "@@/utilities/dictionary";

const vats = [0, 0.06, 0.12, 0.25] as const;
type VAT = (typeof vats)[number];
const vatMap = toObjectMap<VAT>([...vats]);

export { vats, vatMap };
export type { VAT };
